import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import Loc from "../../services/localization";
import CONFIG_COMPANY from "../../services/myConfig";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            showType: 'DAY',
            enableFuture: -2,
            hideTitle: false,
            isLoading: true,
            programToken: '',
            autoOpenIfOnce: false,
            filters: [
                {
                    id: 1,
                    label: LocService.t('label_program_filter_all')
                },
                {
                    id: 2,
                    label: LocService.t('label_program_filter_bought')
                },
                {
                    id: 3,
                    label: LocService.t('label_program_filter_free')
                },
                {
                    id: 4,
                    label: LocService.t('label_program_filter_lock')
                },
            ],
            selectedfilter: 1,
            programs: [],
            expandedDescriptions: {},
            dynamicColors: {},
            defaultBgColor: 'FF1C242D'
        }
    },
    methods: {
        load: load,
        getName: getName,
        getShortDesc: getShortDesc,
        getLongDesc: getLongDesc,
        showProgram: showProgram,
        getDynamicColor: getDynamicColor,
        onSelectType: onSelectType,
        getChipClass: getChipClass,
        isSelected: isSelected,
        getConfig: getConfig,
        getMaxChars: getMaxChars,
        getDateDisplay: getDateDisplay,
        getPageBgStyle: getPageBgStyle,
        isDescriptionExpanded: isDescriptionExpanded,
        toggleDescription: toggleDescription,
    },

    computed: {
        filteredPrograms() {
            if(this.selectedfilter === 2){
                return this.programs.filter(p => p.enabled != null && p.enabled === true);
            }else if(this.selectedfilter === 3){
                return this.programs.filter(p => p.free != null && p.free === true);
            }else if(this.selectedfilter === 4){
                return this.programs.filter(p => {
                    let free = p.free != null ? p.free : false;
                    let enabled = p.enabled != null ? p.enabled : false;
                    return !enabled && !free
                });
            }else{
                return this.programs;
            }
        }
    },

    beforeMount() {
        this.programToken = this.$route.query.programToken;
        if(this.$route.query.showType != null){
            this.showType = this.$route.query.showType;
        }
        if(this.$route.query.enableFuture != null){
            this.enableFuture = this.$route.query.enableFuture;
        }
        if(this.$route.query.hideTitle != null){
            this.hideTitle = this.$route.query.hideTitle;
        }
        if(this.$route.query.autoOpenIfOnce != null){
            this.autoOpenIfOnce = this.$route.query.autoOpenIfOnce;
        }
        this.getConfig()
        this.dynamicColors = session.getAppColors() || {};
        this.role = session.getRole();
        this.load()
    }
}

function getConfig(){
    if(!session.shouldFetchConfig()) {
        // return;
    }
    AdminApiService.getCompanyConfiguration(CONFIG_COMPANY.NAME)
        .then((response) => {
            session.saveConfig(response.data)
            session.setLastFetchConfig();
            this.dynamicColors = session.getAppColors() || {};
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


function load() {
    this.isLoading = true;
    let _self = this;

    AdminApiService.getMyPersonalProgramsUser()
        .then((response) => {
            _self.programs = response.data;
            if(_self.programs.length === 1 && _self.autoOpenIfOnce){
                _self.showProgram(_self.programs[0], false)
            }
            _self.isLoading = false
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getMaxChars(str, maxChars) {
    if(str == null) return ''
    // Provera da li je ulazni string duži od maksimalnog broja karaktera
    if (str.length > maxChars) {
        // Ako jeste, vraćamo prvih maxChars karaktera
        return str.substring(0, maxChars);
    } else {
        // Ako nije, vraćamo ceo ulazni string
        return str;
    }
}

function getDynamicColor(itemId, defaultColor){
    if(this.dynamicColors[itemId] != null){
        return 'color: #'+ this.dynamicColors[itemId];
    }
    if(defaultColor == null) return ''
    return 'color: #'+ defaultColor;
}

function resolveBgColor(raw, fallback){
    if(raw == null) return fallback;
    let value = ('' + raw).trim();
    if(value.length === 0) return fallback;
    if(value[0] === '#') value = value.substring(1);

    // Backend often sends AARRGGBB; convert to RRGGBB for CSS.
    if(value.length === 8){
        value = value.substring(2);
    }

    if(value.length !== 6 && value.length !== 3) return fallback;
    return '#' + value;
}

function getPageBgStyle(){
    const bgRaw = this.dynamicColors != null && this.dynamicColors.BG != null ? this.dynamicColors.BG : this.defaultBgColor;
    return {
        '--personal-page-bg': resolveBgColor(bgRaw, '#1C242D')
    };
}


function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getShortDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function getLongDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.longDescription;
    }else if(item.enLongDescription != null && item.enLongDescription.length > 0){
        return  item.enLongDescription;
    }
    return item.longDescription;
}

function getDateDisplay(item){
    let fromDate = this.$moment(item.startTime * 1000).format('DD-MM-YYYY');
    let toDate = this.$moment(item.endTime * 1000).format('DD-MM-YYYY');
    return fromDate + " - " + toDate;
}

function showProgram(item, showBackButton) {
    const programStyle = CONFIG_COMPANY.ENABLE_NEW_DESIGN_OF_PERSONAL_PROGRAMS != null ? CONFIG_COMPANY.ENABLE_NEW_DESIGN_OF_PERSONAL_PROGRAMS : false;
    let url = programStyle ? '/personal-user-details-program-new' : '/personal-user-details-program'
    if(item.enabled || item.free === true){
        this.$router.push(url + '?id=' +
            item.id +
            '&name='+this.getName(item)+
            '&showType='+ this.showType +
            '&enableFuture='+ this.enableFuture +
            '&hideTitle='+ this.hideTitle +
            '&showBackButton='+ showBackButton +
            '&programToken='+this.programToken)
    }else{
        window.open('https://admin.terminmaster.com/buy-program?programId=' + item.id + '&name='+this.getName(item));
    }
}
//
// function addCompany() {
//     this.$router.push('/add-company-payment')
// }


function onSelectType(item){
    this.selectedfilter = item.id;
}

function getChipClass(item){
    if(this.selectedfilter === item.id){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item){
    return this.selectedfilter === item.id
}

function isDescriptionExpanded(item){
    if(item == null || item.id == null) return false;
    return this.expandedDescriptions[item.id] === true;
}

function toggleDescription(item){
    if(item == null || item.id == null) return;
    const current = this.expandedDescriptions[item.id] === true;
    this.$set(this.expandedDescriptions, item.id, !current);
}



// WEBPACK FOOTER //
// ./src/components/Personal/PersonalListProgramNewUser.js